export class Params {
  id: number;
  referenceId: number;
  type: ParamType;
  key: ParamKey;
  value: any;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }
}

export enum ParamType {
  STORE = 'STORE',
  PLACE = 'PLACE',
}

export enum ParamKey {
  MINIMUM_DELIVERY_PRICE = 'MINIMUM_DELIVERY_PRICE',
  MANAGER_BY_PLACE = 'MANAGER_BY_PLACE',
  ALLOW_ORDER_RESERVATION = 'ALLOW_ORDER_RESERVATION',
  ALLOW_ONLY_ORDER_RESERVATION = 'ALLOW_ONLY_ORDER_RESERVATION',
  RESET_QUEUE_NUMBER = 'RESET_QUEUE_NUMBER',

  //NOTIFICATIONS
  WHATSAPP_NOTIFICATION_AUTO = 'WHATSAPP_NOTIFICATION_AUTO',
  WHATSAPP_NOTIFICATION_MANUAL = 'WHATSAPP_NOTIFICATION_MANUAL',
  SMS_NOTIFICATION = 'SMS_NOTIFICATION',

  //INTEGRATIONS
  META_PIXEL = 'META_PIXEL',
}



// WEBPACK FOOTER //
// ./src/app/shared/models/params.model.ts